import LogosAndParagraphLogosComponent from "./logos-and-paragraph-logos-component";
import LogosAndParagraphLogosConfig from "./logos-and-paragraph-logos-config";
import LogosAndParagraphLogosAdvancedConfig from "./logos-and-paragraph-logos-advanced-config";

export default {
  LogosAndParagraphLogosComponent,
  LogosAndParagraphLogosConfig,
  LogosAndParagraphLogosAdvancedConfig
};
